<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Loading from "$app/components/Loading.svelte"
  import Honeybadger from "$app/utils/honeybadger"

  interface Props {
    attachment: any
    operation?: string
    oncreate?: (attachment: AttachmentType) => void
    onupdate?: (attachment: AttachmentType) => void
    oncancel?: () => void
  }

  let {
    attachment,
    operation = "update",
    oncreate,
    onupdate,
    oncancel
  }: Props = $props()

  let form = $state({ ...attachment })
  let errors: any = $state({})
  let saving = $state(false)

  async function updateAttachment(): Promise<any> {
    saving = true

    try {
      const resp = await xhr.put<AttachmentType>(
        `/plans/${attachment.plan_id}/attachments/${attachment.id}`,
        {
          [`attachment`]: { name: form.name, description: form.description }
        }
      )
      onupdate(resp.data)
    } catch (e: any) {
      toast("There was an error updating the goal attachment", "error")
      if (e.response.data) {
        errors = e.response.data.errors
      } else {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
      }
    } finally {
      saving = false
    }
  }

  async function createAttachment(): Promise<void> {
    saving = true

    const formData = new FormData()
    formData.append("attachment[attachable_id]", attachment.attachable_id)
    formData.append("attachment[attachable_type]", attachment.attachable_type)

    if (form.name) {
      formData.append("attachment[name]", form.name)
    }
    if (form.description) {
      formData.append("attachment[description]", form.description)
    }
    if (file) {
      formData.append("attachment[file]", file)
    } else {
      errors = { file: "Please select a file" }
      saving = false
      return
    }

    try {
      const resp = await xhr.post<AttachmentType>(
        `/plans/${attachment.plan_id}/attachments`,
        formData
      )

      oncreate(resp.data)
    } catch (e: any) {
      if (e.response && e.response.data) {
        errors = { ...errors, ...e.response.data.errors }
      } else {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
      }
      toast("There was an error creating the attachment", "error")
    } finally {
      saving = false
    }
  }

  let file: any,
    fileInput: HTMLInputElement = $state()

  const onFileSelected = (e) => {
    file = e.target.files[0]
  }
</script>

<div class="sm:flex w-full" data-name="progress-form">
  <div class="w-full">
    <div class="mt-2 grid grid-cols-1 gap-y-2">
      <div>
        <label for="username" class="block text-sm font-medium text-gray-700"
          >Name</label
        >
        <div class="input-cont" class:error={errors.name}>
          <input bind:value={form.name} type="text" required class="input" />
          <div class="msg">{errors.name}</div>
        </div>
      </div>

      <div>
        <label for="about" class="block text-sm font-medium text-gray-700"
          >Description <span class="text-gray-400">(Optional)</span></label
        >
        <div class="mt-1">
          <textarea
            rows="2"
            bind:value={form.description}
            class="input flex-auto"
          ></textarea>
          {errors.description ? errors.description : ""}
        </div>
      </div>
      <div>
        <label for="about" class="block text-sm font-medium text-gray-700">
          File
        </label>
        <div class="input-cont" class:error={errors.file}>
          <input
            class="input"
            type="file"
            bind:this={fileInput}
            required
            onchange={onFileSelected}
          />
          <div class="msg">{errors.file}</div>
        </div>
      </div>
    </div>
    <div class="pt-5">
      <div class="flex justify-end">
        <button
          disabled={saving}
          data-name="cancel-progress"
          class="btn secondary px-4 ml-2"
          onclick={() => oncancel()}
        >
          Cancel
        </button>
        <Loading loading={saving} class="flex">
          <button
            class="btn btn-primary ml-2 px-4"
            data-name="save-progress"
            onclick={() => {
              if (operation === "update") {
                updateAttachment()
              } else {
                createAttachment()
              }
            }}
          >
            {operation === "update" ? "Update" : "Upload & Save"}
          </button>
        </Loading>
      </div>
    </div>
  </div>
</div>
